module.exports = __webpack_public_path__ + "static/media/Skiploom_gaussian2.08f7be80.png";